import { pathJoin } from 'src/reducers/routing/utils'

export const createPricingRoutesMap = (prefix: string) => ({
  containers: pathJoin(prefix)('containers').chain,
  services: pathJoin(prefix)('services').chain,
  recurring: pathJoin(prefix)('recurring').chain,
  // 'vat-rates' was removed — VAT-rates management lives on Company Settings >
  // Finance now. The old path still redirects (see
  // product-management/route-config.tsx in the settings layer).
  //
  // PRO-777: 'agreement-templates' was removed too — the register is its own
  // Products & prices page now (`createProductManagementRoutesMap`), because
  // it is a live P&P surface rather than part of this retiring catalogue. The
  // old path still redirects (`createLegacyAgreementTemplatesRedirects`).
})
